// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useFlags } from 'launchdarkly-react-client-sdk';
import { LD_FLAGS, type LDFlagName } from '../config/launchDarklyFlags';
import { envFlagDefault } from '../config/featureFlags';

/**
 * Typed read of one catalog flag (config/launchDarklyFlags.ts). Always
 * returns a boolean: LaunchDarkly's value when it has a boolean, else the
 * environment's `REACT_APP_FLAG_*` value (config/featureFlags.ts), else the
 * catalog `default`. "Flag not found", "LaunchDarkly not configured" and
 * "value came back a non-boolean" all take the same fallback path, so every
 * call site gets one predictable type instead of checking for undefined.
 */
export function useFeatureFlag(name: LDFlagName): boolean {
  const flags = useFlags();
  const { key, default: fallback } = LD_FLAGS[name];
  const value = flags[key];
  return typeof value === 'boolean' ? value : (envFlagDefault(name) ?? fallback);
}
